import AWS from 'aws-sdk';

AWS.config = new AWS.Config();
AWS.config.region = 'us-east-2';
AWS.config.accessKeyId = 'AKIA33TYC4AG3VL5T4UW';
AWS.config.secretAccessKey = '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';

export const s3BucketName =
  process.env.REACT_APP_AWS_S3_DOCS_BUCKET_NAME || 'munitech-dev';
export const s3Bucket = 'munitech';
export const s3 = new AWS.S3();

export async function deleteS3File(name: any) {
  return s3
    .deleteObject({
      Bucket: s3Bucket,
      Key: 'upload/videos/' + name,
    })
    .promise();
}

export async function deleteUploadDocuments(name: any) {
  return s3
    .deleteObject({
      Bucket: s3Bucket,
      Key: 'transaction_docs/' + name,
    })
    .promise();
}
